// import { TextField } from "@mui/material";
import { useContext, useState } from "react";
import "./Header.css";
import { useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Cart } from "../Cart/Cart";
import { Search } from "./Search/Search";
import {useNavigate} from "react-router-dom";
import { Context } from "../../utils/context";


export function Header(){
    const [scrolled, setSrolled] = useState(false);
    const [click, setClick] = useState(false);
    const [showCart, setShowCart] = useState(false);
    const [showSearch, setShowSearch] = useState(false);

    const navigate = useNavigate();
    const {cartCount} = useContext(Context);

    function handleClick(){
        setClick(!click);
    }

    function handleScroll(){
        var offset = window.scrollY;
        if(offset > 200){
            setSrolled(true);
        }else{
            setSrolled(false);
        }
    };

    useEffect(()=>{
        window.addEventListener("scroll", handleScroll)
    },[]);
    return(
       <>
        <div className="sticky">
           <header className={`d-flex justify-content-between p-2 ${scrolled ? "sticky-header" : ""}`}>
            <div className="brand-logo">
                <h2 onClick={() => navigate("/")} className="brand-name">Zeenat Mobile Shop</h2>
            </div>
           <div className="dis">
           <ul className={click ? "nav-menu active" : "nav-menu"}>
                <li onClick={() => navigate("/")} className="bi bi-house-heart"> Home</li>
                <li onClick={() => navigate("/about")} className="bi bi-person-heart"> About</li>
                <li className="bi bi-tags"> Categories</li>
            </ul>
            </div>
            <div className="hamburger" onClick={handleClick}>
            {click ? (
          <FaTimes size={20} style={{ color: "#ffff" }} />
        ) : (
          <FaBars size={20} style={{ color: "#ffff" }} />
        )}
            </div>
           <div className="btn-size">
           {/* <TextField label="Serach" variant="standard" color="success" />  */}
           <button onClick={()=>{setShowSearch(true)}} className="btn-sm me-1 btn btn-outline-success bi bi-search-heart"></button>
            <button className="btn-sm me-1 btn btn-outline-success bi bi-suit-heart"></button>
            <button onClick={()=>{setShowCart(true)}} className="btn-sm me-1 btn btn-outline-success bi bi-bag-heart position-relative">
                {!! cartCount && <span className=" btn btn-outline-success circle rounded badge bg-secondary text-white position-absolute">{cartCount}</span>}
            </button>
           </div>
           </header>
           {showCart && <Cart setShowCart={setShowCart}/>}
           {showSearch && <Search setShowSearch={setShowSearch} />}
        </div>
       </>
    )
}
